import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[isophiSidemenuToggle]',
    standalone: false
})
export class SidemenuToggleDirective {
  private body: any = document.querySelector('body');

  @HostListener('click') toggleSidemenu() {
    if (this.body !== !this.body) {
      document.querySelector('body')?.classList.toggle('sidenav-toggled');
    }
  }
}
